/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:36:37
 * @LastEditors: Gaho
 * @LastEditTime: 2023-12-29 14:42:41
 */
const s = {
    ballDistance: 29.2,
    diameter: 9,
    numRows: 9,
    yMult: 1.24,
    ballProp: {
        mass: 1.1,
        densety: .9,
        friction: {
            x: .97,
            y: .93
        }
    },
    xps: {
        0: [234.6421427706577, 231.97104841698982, 193.33798409175733, 194.65558796790128, 234.95666073730376, 232.92661391006806, 193.50809836333468, 195.66101507455636],
        1: [234.22935417117966, 232.97977657845752, 194.18945942743517, 194.20772627502828, 194.64467417476922, 234.6472242815054, 232.81819527992278, 196.4953560060414],
        2: [231.66490321198123, 195.7210720155359, 232.2042016693926, 196.10907356642048, 233.7893087552851, 233.96052976647414, 193.37288132521675, 233.04888506832873],
        3: [234.2126863658729, 233.11343238178642, 192.98800588319233, 233.77414932725532, 233.83822070494423, 194.94963247560773, 196.79461526421483, 231.46232579920996],
        4: [195.43098643139646, 234.81562925053373, 194.923473385947, 232.9690300482853, 232.86371199239227, 196.546811804285, 193.30491443371957, 232.73797858831512],
        5: [193.85027330903426, 234.84765245290427, 195.64775671116251, 196.65201658335312, 234.8456101342031, 194.39026531951154, 231.30779556644939, 232.67235697375935],
        6: [232.38425466213448, 232.92498725864527, 231.2888693919061, 194.68094075380637, 233.53771439666372, 233.05341231014447, 193.42846362085106, 232.163737642256],
        7: [233.68541231789223, 232.59011619496076, 233.33749808766794, 233.22664086109242, 195.11983638872474, 232.59898127541342, 194.95044911203607, 234.88444477512402],
        8: [234.03612199156487, 233.74702419124782, 232.9915944211507, 195.00548758380998, 231.9678758045363, 195.07675801578966, 193.0704390522112, 234.90843509834656],
        9: [196.23339096737968, 196.41005174206748, 233.93753522340737, 194.60973847509544, 193.66394040817798, 196.37926523737795, 234.94709729386713, 232.6600958286207],
        10: []
    }
};
export {s as default};
